<div class="content pr-4">
    <div class="content-header">
        <h1>Reporte de generación de presorteos</h1>
        <p>Espacio para descargar los reportes de presorteos generados anteriormente</p>
    </div>
    <div class="content-body">
        <div class="card p-mt-3">
            <p-table #dt [value]="registrations" dataKey="id" [rows]="10" [rowsPerPageOptions]="[10, 25, 50]"
                styleClass="p-datatable-customers p-datatable-gridlines" [paginator]="true"
                [globalFilterFields]="['dateGameLottery', 'codeLottery']" sortField="dateGameLottery" [sortOrder]="-1">
                <ng-template pTemplate="caption">
                    <div class="table-header p-d-flex p-ai-center p-jc-between">
                        <div class="holderName">
                            <p>Reporte de presorteos creados</p>
                        </div>
                        <div>
                            <span class="p-input-icon-left p-ml-auto">
                                <i class="pi pi-search ml-2"></i>
                                <input pInputText type="text" class="pl-6"
                                    (input)="applyFilterGlobal($event, 'contains')"
                                    placeholder="Búsqueda por código o fecha" />
                            </span>
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="dateGameLottery">
                            Fecha<p-sortIcon field="dateGameLottery"></p-sortIcon>
                        </th>
                        <th pSortableColumn="codeLottery">
                            Código de sorteo<p-sortIcon field="codeLottery"></p-sortIcon>
                        </th>
                        <th>Herramientas</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-report>
                    <tr>
                        <td style="text-align: center">{{ report.dateGameLottery }}</td>
                        <td style="text-align: center">{{ report.codeLottery }}</td>
                        <td style="text-align: center">
                            <button pButton pRipple (click)="printReport(report.id)" type="button" label=" "
                                class="p-button-secondary">
                                <i class="pi pi-download" style="font-size: 1.2rem"></i>
                            </button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>